<template>
  <div>
    <b-row>
      <!-- ==============================  FILTERS_SECTION START ============================== -->
      <b-col class="col-md-2">
        <AppSearchInput
          v-if="card == 'Материалы'"
          v-model="paramsMaterial.search"
          :label="$t('search') + ':'"
          :placeholder="$t('search') + '...'"
          @callback="refresh()"
        />
        <AppSearchInput
          v-if="card == 'Инструменты'"
          v-model="paramsInstruments.search2"
          :label="$t('search') + ':'"
          :placeholder="$t('search') + '...'"
          @callback="refresh()"
        />
      </b-col>

      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('filter_by_destination_warehouse') + ':'" v-if="checkButtonPermission(['admin'])">
          <v-select
            v-if="card == 'Материалы'"
            v-model="paramsMaterial.to_storage"
            class="bg-white rounded"
            label="title"
            :options="GET_APPLICATION_TYPE"
            :reduce="(p) => p.id"
            @input="onFiltered"
          />
          <v-select
            v-if="card == 'Инструменты'"
            v-model="paramsInstruments.to_storage2"
            class="bg-white rounded"
            label="title"
            :options="GET_APPLICATION_TYPE"
            :reduce="(p) => p.id"
            @input="onFiltered"
          />
        </b-form-group>
      </b-col>

      <b-col
        class="col-lg-2 col-md-3 col-12"
      >
        <b-form-group :label="$t('filter_by_author') + ':'" v-if="checkButtonPermission(['admin'])">
          <v-select
            v-if="card == 'Материалы'"
            v-model="paramsMaterial.author"
            class="bg-white rounded"
            :get-option-label="(el) => {return el.first_name + ' ' + el.last_name;}"
            label="name"
            :options="GET_APPLICATION_AUTHOR.results"
            :reduce="(p) => p.id"
            @input="onFiltered"
            @search="onAuthorSearch"
          >
            <li slot="list-footer" class="pagination">
              <button :disabled="!GET_APPLICATION_AUTHOR.previous" @click="previousAuthor">
                {{ $t("prev") }}
              </button>
              <button :disabled="!GET_APPLICATION_AUTHOR.next" @click="nextAuthor">
                {{ $t("next") }}
              </button>
            </li>
          </v-select>
          <v-select
            v-if="card == 'Инструменты'"
            v-model="paramsInstruments.author"
            class="bg-white rounded"
            :get-option-label="(el) => {return el.first_name + ' ' + el.last_name;}"
            label="name"
            :options="GET_APPLICATION_AUTHOR.results"
            :reduce="(p) => p.id"
            @input="onFiltered"
            @search="onAuthorSearch"
          >
            <li slot="list-footer" class="pagination">
              <button :disabled="!GET_APPLICATION_AUTHOR.previous" @click="previousAuthor">
                {{ $t("prev") }}
              </button>
              <button :disabled="!GET_APPLICATION_AUTHOR.next" @click="nextAuthor">
                {{ $t("next") }}
              </button>
            </li>
          </v-select>
        </b-form-group>
      </b-col>

      
    

      <!-- ==============================  FILTERS_SECTION END ============================== -->

      <b-col
        class="col-6 d-flex align-items-center justify-content-end"
        style="margin-top: 10px"
      >
        <b-form-radio-group
          id="radio-group-1"
          v-model="card"
          class="list item-view-radio-group"
          :options="itemViewOptions"
          buttons
          @input="onFiltered()"
          button-variant="outline-primary"
        >
        </b-form-radio-group>
      </b-col>

      <b-col v-if="!isLoading">
        <!-- <b-card> -->
        <b-table
          v-if="card == 'Материалы'"
          id="user-table"
          class="px-1 rounded mt-1 bg-light-secondary"
          :fields="fields"
          :items="worker_write_off_for_good.results"
          show-empty
          :tbody-tr-class="['tableRowClass']"
          small
          responsive
          :empty-text="$t('empty_text')"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #cell(type)="{ item }">
            <b-badge
              v-for="(item1, index) in item.objects"
              :key="index"
              variant="success"
              class="ml-50"
            >
              {{ item1.product }}
            </b-badge>
          </template>


          <template #cell(good)="{ item }">
            <b-badge
              v-for="(item1, index) in item.objects"
              :key="index"
              variant="success"
              class="ml-50"
            >
              {{ item1.good }} - {{ $_formatPriceMixin(item1.quantity) }}
            </b-badge>
          </template>
               
       
          <template #cell(actions)="props">
            <div class="d-flex align-items-center justify-content-center">
              <b-button
                variant="primary"
                size="sm"
                class="mt-50 mb-50"
                @click="$router.push(`/applications/material/view/${props.item.requirement_id}/`)"
              >
                <feather-icon icon="ChevronsRightIcon" size="18" />
              </b-button>

              <template v-if="props.item.status">
                <template v-for="(item, index) in props.item.status.change_to">
                    <!-- v-if="checkButtonPermission([...item.roles])" -->
                  <b-button
                    :key="index"
                    v-b-tooltip.hover="{ variant: item.color }"
                    :title="item.name"
                    size="sm"
                    class="ml-50"
                    :variant="item.color"
                    @click="onChangeStatus(props, props.item, item)"
                  >
                    {{ $t('accept') }}
                  </b-button>
                </template>
              </template>
            </div>
          </template>
        </b-table>


        <b-table
          v-if="card == 'Инструменты'"
          id="user-table"
          class="px-1 rounded mt-1 bg-light-secondary"
          :fields="fieldsInstrument"
          :items="worker_write_off_for_instrument.results"
          show-empty
          :tbody-tr-class="['tableRowClass']"
          small
          responsive
          :empty-text="$t('empty_text')"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>


          <template #cell(type)="{ item }">
            <b-badge
              v-for="(item1, index) in item.objects"
              :key="index"
              variant="success"
              class="ml-50"
            >
              {{ item1.product }}
            </b-badge>
          </template>


          <template #cell(intrument)="{ item }">
            <b-badge
              v-for="(item1, index) in item.objects"
              :key="index"
              variant="success"
              class="ml-50"
            >
              {{ item1.good }} - {{ $_formatPriceMixin(item1.quantity) }}
            </b-badge> 
          </template>
          

          <template #cell(actions)="props">
            <div class="d-flex align-items-center justify-content-center">
              <b-button
                variant="primary"
                size="sm"
                class="mt-50 mb-50"
                @click="$router.push(`/applications/material/view/${props.item.requirement_id}/`)"
              >
                <feather-icon icon="ChevronsRightIcon" size="18" />
              </b-button>

              <template v-if="props.item.status">
                <template v-for="(item, index) in props.item.status.change_to">
                  <b-button
                    :key="index"
                    v-b-tooltip.hover="{ variant: item.color }"
                    :title="item.name"
                    size="sm"
                    class="ml-50 mt-50 mb-50"
                    :variant="item.color"
                    @click="onChangeStatus(props, props.item, item)"
                  >
                    {{ $t('accept') }}
                  </b-button>
                </template>
              </template>
            </div>
          </template>

        </b-table>
        <!-- </b-card> -->
      </b-col>
      <b-col v-else>
        <b-card>
          <Loader />
        </b-card>
      </b-col>




      <!-- ==============================  PAGINATION_SECTION START ============================== -->
      <Pagination
        class="w-100"
        v-if="card == 'Материалы'"
        :params="paramsMaterial"
        :rows="worker_write_off_for_good.count"
        @refresh="refresh()"
      />
      <Pagination
        class="w-100"
        v-if="card == 'Инструменты'"
        :params="paramsInstruments"
        :rows="worker_write_off_for_instrument.count"
        @refresh="refresh()"
      />
      <!-- ==============================  PAGINATION_SECTION END ============================== -->




    </b-row>
  </div>
</template>

<script>
import {
  BCol,
  BRow,
  BButton,
  BTable,
  BFormRadio,
  BFormRadioGroup,
  BCard,
  BFormGroup,
  BBadge,
  VBTooltip,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapState } from "vuex";
import vSelect from "vue-select";
import AppSearchInput from "@/components/AppSearchInput.vue";
import VueDataPicker from "@/components/VueDatePicker.vue";
import Pagination from "@/components/Pagination.vue";
import areYouSure from "@/mixins/areYouSure";
import addQueryToCurrentPage from "@/mixins/addQueryToCurrentPage";
import check from "@/mixins/check";
import { getUserData } from "@/auth/utils";
import loader from "@/mixins/loader";
import Loader from "@/components/Loader.vue";
import priceFormatMixin from "@/mixins/priceFormatMixin";

export default {
  components: {
    BCol,
    BRow,
    BButton,
    BFormGroup,
    vSelect,
    AppSearchInput,
    VueDataPicker,
    BTable,
    BBadge,
    Loader,
    BCard,
    Pagination,
    BFormRadio,
    BFormRadioGroup,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  mixins: [areYouSure, check, loader, addQueryToCurrentPage, priceFormatMixin],
  data() {
    return {
      isLoading: false,
      // ==================== PRIMARY_SECTION START ====================
      card: "Материалы",
      paramsMaterial: {
        search: "",
        to_storage: "",
        author: "",
        requirement_type: '',

        page_size: 10,
        page: 1,
      },
      paramsInstruments: {
        search2: "",
        to_storage2: "",
        author: "",
        requirement_type: '',

        page_size2: 10,
        page2: 1,
      },
      itemViewOptions: [
        {
          text: this.$t("reference.material"),
          value: "Материалы",
        },
        {
          text: this.$t("reference.instrument"),
          value: "Инструменты",
        },
      ],
      dateFilter: {
        start_date: '',
        end_date: '',
      },
      dateFilter2: {
        start_date2: '',
        end_date2: '',
      },
      // ==================== PRIMARY_SECTION END ====================








      // ==================== OTHERS_SECTION START ====================
      fields: [
        {
          label: "application_number",
          key: "requirement_id",
          thClass: "tableHeadClass",
        },
        {
          label: "destination_warehouse",
          key: "storage",
          thClass: "tableHeadClass",
        },
        {
          label: "author",
          key: "author",
          thClass: "tableHeadClass",
        },
        {
          label: "courses.type",
          key: "type",
          thClass: "tableHeadClass",
        },
        {
          label: "namee",
          key: "good",
          thClass: "tableHeadClass",
        },
        // {
        //   label: "general.created_at",
        //   key: "created_at",
        //   formatter: (data) => this.$dayjs(data).format("DD.MM.YYYY"),
        //   thClass: "tableHeadClass",
        // },
        // {
        //   label: "status",
        //   key: "status",
        //   formatter: (data) => data?.name,
        //   thClass: "tableHeadClass",
        // },
        {
          label: "actions",
          key: "actions",
          thClass: "tableHeadClass",
        },
      ],

      fieldsInstrument: [
        {
          label: "application_number",
          key: "application_number",
          thClass: "tableHeadClass",
        },
        {
          label: "destination_warehouse",
          key: "destination_warehouse",
          thClass: "tableHeadClass",
        },
        {
          label: "author",
          key: "author",
          thClass: "tableHeadClass",
        },
        {
          label: "courses.type",
          key: "goods",
          thClass: "tableHeadClass",
        },
        {
          label: "namee",
          key: "good",
          thClass: "tableHeadClass",
        },
        // {
        //   label: "general.created_at",
        //   key: "created_at",
        //   formatter: (data) => this.$dayjs(data).format("DD.MM.YYYY"),
        //   thClass: "tableHeadClass",
        // },
        // {
        //   label: "status",
        //   key: "status",
        //   formatter: (data) => data?.name,
        //   thClass: "tableHeadClass",
        // },
        {
          label: "actions",
          key: "actions",
          thClass: "tableHeadClass",
        },
      ],
      // ==================== OTHERS_SECTION END ====================







    };
  },
  computed: {
    ...mapState("application", [
      "worker_write_off_for_good",
      "worker_write_off_for_instrument",
    ]),
    ...mapGetters("application", [
      "GET_APPLICATION_TYPE",
      "GET_APPLICATION_AUTHOR",
    ]),
  },
  watch: {

  },
  async mounted() {
    // await this.$_loaderStart();
    this.isLoading = true;




    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_WORKER_WRITE_OFF_FOR_GOOD({
      page: this.$route.query.page ? this.$route.query.page : 1,
      page_size: this.$route.query.page_size ? this.$route.query.page_size : 10,

      search: this.$route.query.search ? this.$route.query.search : '',
      to_storage: this.$route.query.to_storage ? this.$route.query.to_storage : '',

      start_date: this.$route.query.start_date ? this.$route.query.start_date : '',
      end_date: this.$route.query.end_date ? this.$route.query.end_date : '',
    });
    await this.FETCH_WORKER_WRITE_OFF_FOR_INSTRUMENT({
      page: this.$route.query.page2 ? this.$route.query.page2 : 1,
      page_size: this.$route.query.page_size2 ? this.$route.query.page_size2 : 10,

      search: this.$route.query.search2 ? this.$route.query.search2 : '',
      to_storage: this.$route.query.to_storage2 ? this.$route.query.to_storage2 : '',

      start_date: this.$route.query.start_date2 ? this.$route.query.start_date2 : '',
      end_date: this.$route.query.end_date2 ? this.$route.query.end_date2 : '',
    });



    let to_storage = this.GET_APPLICATION_TYPE.find((elem) => elem.id == this.$route.query.to_storage)
    if(to_storage){
      this.paramsMaterial.to_storage = {id: to_storage.id, title: to_storage.title}
    }


    let to_storage2 = this.GET_APPLICATION_TYPE.find((elem) => elem.id == this.$route.query.to_storage2)
    if(to_storage2){
      this.paramsInstruments.to_storage2 = {id: to_storage2.id, title: to_storage2.title}
    }


    this.card = this.$route.query.card ? this.$route.query.card : 'Материалы';
    
    this.paramsMaterial.search = this.$route.query.search ? this.$route.query.search : '';
    this.paramsInstruments.search2 = this.$route.query.search2 ? this.$route.query.search2 : '';

    this.dateFilter.start_date = this.$route.query.start_date ? this.$route.query.start_date : '';
    this.dateFilter.end_date = this.$route.query.end_date ? this.$route.query.end_date : '';

    this.dateFilter2.start_date2 = this.$route.query.start_date2 ? this.$route.query.start_date2 : '';
    this.dateFilter2.end_date2 = this.$route.query.end_date2 ? this.$route.query.end_date2 : '';

    this.paramsMaterial.page_size = this.$route.query.page_size ? this.$route.query.page_size : 10;
    this.paramsInstruments.page_size2 = this.$route.query.page_size2 ? this.$route.query.page_size2 : 10;


    setTimeout(() => {
      this.paramsMaterial.page = this.$route.query.page ? this.$route.query.page : 1;
      this.paramsInstruments.page2 = this.$route.query.page2 ? this.$route.query.page2 : 1;
    }, 0)
    // ===============  PRIMARY_REQUESTS_SECTION END ===============






    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_APPLICATION_AUTHOR({ role_unique_name: "builder" });
    await this.FETCH_APPLICATION_STATUS({ content_type_model: "requirements" });
    await this.FETCH_APPLICATION_TYPE({ is_object: 1, mini: true });
    // ===============  PRIMARY_REQUESTS_SECTION END ===============
    this.isLoading = false;
  },

  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },

  methods: {
    ...mapActions("application", [
      "FETCH_WORKER_WRITE_OFF_FOR_GOOD",
      "FETCH_WORKER_WRITE_OFF_FOR_INSTRUMENT",
      "UPDATE_APPLICATION_MATERIAL_MOVEMENT",
      "UPDATE_APPLICATION_INSTRUMENT_MOVEMENT",
    ]),
    ...mapActions('materials', ['UPDATE_WRITE_OFF_FOR_GOOD', 'UPDATE_WRITE_OFF_FOR_INSTRUMENT']),
    ...mapActions("application", [
      "FETCH_APPLICATION_STATUS",
      "FETCH_APPLICATION_AUTHOR",
      "FETCH_APPLICATION_TYPE",
    ]),











    // =============== REFRESH_SECTION START ===============
    async refresh() {
      this.isLoading = true;

      let filter = {}
      if(this.paramsInstruments.page){
        this.paramsInstruments.page2 = this.paramsInstruments.page
      }
      filter = {...this.paramsMaterial, ...this.paramsInstruments}


      if (this.card == "Материалы") {

        if(this.paramsMaterial.to_storage){
          filter.to_storage = typeof this.paramsMaterial.to_storage == "number" ? this.paramsMaterial.to_storage : this.paramsMaterial.to_storage.id
        }

        await this.FETCH_WORKER_WRITE_OFF_FOR_GOOD({
          ...this.paramsMaterial,
          start_date: this.dateFilter.start_date,
          end_date: this.dateFilter.end_date,
        });


      } else {

        if(this.paramsInstruments.to_storage2){
          filter.to_storage = typeof this.paramsInstruments.to_storage2 == "number" ? this.paramsInstruments.to_storage2 : this.paramsInstruments.to_storage2.id
        }

        await this.FETCH_WORKER_WRITE_OFF_FOR_INSTRUMENT({
          ...this.paramsInstruments,
          start_date: this.dateFilter2.start_date,
          end_date: this.dateFilter2.end_date,
        });

      }

      
      let dates = {
        start_date: this.dateFilter && this.dateFilter.start_date ? this.dateFilter.start_date : '',
        end_date: this.dateFilter && this.dateFilter.end_date ? this.dateFilter.end_date : '',
        start_date2: this.dateFilter2 && this.dateFilter2.start_date2 ? this.dateFilter2.start_date2 : '',
        end_date2: this.dateFilter2 && this.dateFilter2.end_date2 ? this.dateFilter2.end_date2 : '',
      }
      this.$_addParamsToLocation({ ...filter, ...dates, card: this.card })
      this.isLoading = false;
    },
    // =============== REFRESH_SECTION END ===============











    // ===============  SEARCH_SECTION START ===============
    async onFiltered() {
      this.isLoading = true;
      let filter = {}
      if(this.paramsInstruments.page){
        this.paramsInstruments.page2 = this.paramsInstruments.page
      }
      filter = {...this.paramsMaterial, ...this.paramsInstruments}

      if (this.card == "Материалы") {
        // this.paramsMaterial.page = 1;

        await this.FETCH_WORKER_WRITE_OFF_FOR_GOOD({
          ...this.paramsMaterial,
          start_date: this.dateFilter.start_date,
          end_date: this.dateFilter.end_date,
        });
      } else {
        // this.paramsInstruments.page2 = 1;

        await this.FETCH_WORKER_WRITE_OFF_FOR_INSTRUMENT({
          ...this.paramsInstruments,
          start_date: this.dateFilter2.start_date,
          end_date: this.dateFilter2.end_date,
        });
      }

      
      let dates = {
        start_date: this.dateFilter && this.dateFilter.start_date ? this.dateFilter.start_date : '',
        end_date: this.dateFilter && this.dateFilter.end_date ? this.dateFilter.end_date : '',
        start_date2: this.dateFilter2 && this.dateFilter2.start_date2 ? this.dateFilter2.start_date2 : '',
        end_date2: this.dateFilter2 && this.dateFilter2.end_date2 ? this.dateFilter2.end_date2 : '',
      }
      this.$_addParamsToLocation({ ...filter, ...dates, card: this.card })
      this.isLoading = false;
    },



    async onAuthorSearch(value) {
      this.isLoading = true;

      if (value) {
        clearTimeout(this._timerId);
        this._timerId = setTimeout(async () => {
          await this.FETCH_APPLICATION_AUTHOR({
            mini: true,
            search: value,
            role_unique_name: "builder",
          });
        }, 500);
      }

      this.isLoading = false;
    },



    async search() {
      this.isLoading = true;
      this.paramsMaterial.page = 1;
      this.paramsInstruments.page2 = 1;
      let filter = {}
      filter = {...this.paramsMaterial, ...this.paramsInstruments}


      if (this.card == "Материалы") {
        await this.FETCH_WORKER_WRITE_OFF_FOR_GOOD({
          ...this.paramsMaterial,
          start_date: this.dateFilter.start_date,
          end_date: this.dateFilter.end_date,
        });
      } else {

        await this.FETCH_WORKER_WRITE_OFF_FOR_INSTRUMENT({
          ...this.paramsInstruments,
          start_date: this.dateFilter2.start_date,
          end_date: this.dateFilter2.end_date,
        });
      }

      let dates = {
        start_date: this.dateFilter && this.dateFilter.start_date ? this.dateFilter.start_date : '',
        end_date: this.dateFilter && this.dateFilter.end_date ? this.dateFilter.end_date : '',
        start_date2: this.dateFilter2 && this.dateFilter2.start_date2 ? this.dateFilter2.start_date2 : '',
        end_date2: this.dateFilter2 && this.dateFilter2.end_date2 ? this.dateFilter2.end_date2 : '',
      }
      this.$_addParamsToLocation({ ...filter, ...dates, card: this.card })
      this.isLoading = false;
    },
    // ===============  SEARCH_SECTION END ===============














    // ===============  DATE_PICKER_SECTION START ===============
    async datePicker(e) {
      this.isLoading = true;
      let filter = {}

      // this.paramsMaterial.page = 1;
      // this.paramsInstruments.page2 = 1;
      if(this.paramsInstruments.page){
        this.paramsInstruments.page2 = this.paramsInstruments.page
      }
      filter = {...this.paramsMaterial, ...this.paramsInstruments}

      if (e) {
        if (this.card == "Материалы" && e.start && e.end) {
          this.dateFilter.start_date = e.start;
          this.dateFilter.end_date = e.end;


          await this.FETCH_WORKER_WRITE_OFF_FOR_GOOD({
            ...this.paramsMaterial,
            start_date: this.dateFilter.start_date,
            end_date: this.dateFilter.end_date,
          });
        } else if (this.card == "Инструменты" && e.start && e.end) {
          this.dateFilter2.start_date2 = e.start;
          this.dateFilter2.end_date2 = e.end;


          await this.FETCH_WORKER_WRITE_OFF_FOR_INSTRUMENT({
            ...this.paramsInstruments,
            start_date: this.dateFilter2.start_date,
            end_date: this.dateFilter2.end_date,
          });
        }
      } else {
        if (this.card == "Материалы") {
          await this.FETCH_WORKER_WRITE_OFF_FOR_GOOD(this.paramsMaterial);
        } else {

          await this.FETCH_WORKER_WRITE_OFF_FOR_INSTRUMENT(this.paramsInstruments);
        }
      }

      let dates = {
        start_date: this.dateFilter && this.dateFilter.start_date ? this.dateFilter.start_date : '',
        end_date: this.dateFilter && this.dateFilter.end_date ? this.dateFilter.end_date : '',
        start_date2: this.dateFilter2 && this.dateFilter2.start_date2 ? this.dateFilter2.start_date2 : '',
        end_date2: this.dateFilter2 && this.dateFilter2.end_date2 ? this.dateFilter2.end_date2 : '',
      }
      this.$_addParamsToLocation({ ...filter, ...dates, card: this.card })
      this.isLoading = false;
    },
    // ===============  DATE_PICKER_SECTION END ===============


















    // =============== ON_CHANGE_STATUS_SECTION START ===============
    onChangeStatus(props, item, item2) {
      const status = {
        accepted_write_off: this.$t("accepted"),
      };
      this.$bvModal
        .msgBoxConfirm(
          this.$t("do_you_really_want") + ` ${status[item2.unique_name]} ?`,
          {
            title: this.$i18n.t("attention"),
            size: "sm",
            okVariant: item2.color,
            okTitle: this.$t("yes"),
            cancelTitle: this.$t("no"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (value) => {
          if (value) {
            if (this.card) {

              let goods = []
              item.objects.forEach(elem => {
                goods.push({good_id: elem.good_id, count: elem.quantity})
              })
              await this.UPDATE_WRITE_OFF_FOR_GOOD({id: item.id, data: {status_unique: 'accepted_write_off', goods: goods}}).then(() => {
                this.refresh();
              }); 


              
            } else {

              
              let instruments = []
              item.objects.forEach(elem => {
                instruments.push({instrument_id: elem.instrument_id, count: elem.quantity})
              })
              await this.UPDATE_WRITE_OFF_FOR_INSTRUMENT({id: item.id, data: {status_unique: 'accepted_write_off', instruments: instruments}}).then(() => {
                this.refresh();
              }); 

            }
          }
        });
    },
    // =============== ON_CHANGE_STATUS_SECTION END ===============







   


  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.item-view-radio-group{
  color: black !important;
}

.dark-layout #radio-group-1 span{
  color: white !important;
}

#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

//  кнопка переключения между заявками и инструментами
[dir] .btn-outline-primary:not(:disabled):not(.disabled).active {
  background-color: #5a9cd9;
  color: white;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}
</style>
